const useContentMethods = (cmsAdapter, languageKey, history, setContentType, setSiaContentProps, setIsLoading, node_id, alias, isEventOccurrence) => {
  const setContent = content => {
    const {
      errors,
      content_type,
      ...data
    } = content;
    if (errors?.length > 0) {
      console.error(`Errors in ${data?.title}: `, errors);
      history.push(`/${languageKey}/error`);
      return;
    }
    setContentType(content_type);
    if (content_type === 'sia_page') {
      const {
        title,
        page_top,
        page_bottom
      } = data;
      setSiaContentProps({
        title,
        page_top,
        page_bottom
      });
    } else if (content_type === 'sektion_page') {
      const {
        title,
        page_top,
        page_bottom,
        section
      } = data;
      setSiaContentProps({
        title,
        page_top,
        page_bottom,
        section
      });
    } else if (content_type === 'speaker') {
      setSiaContentProps(data);
    } else {
      setSiaContentProps({
        item: data
      });
    }
    setIsLoading(false);
  };
  const getContentByHash = () => {
    cmsAdapter.fetchNodeByHash(languageKey, alias, setContent);
  };
  const getContentByNodeID = () => {
    if (isEventOccurrence) {
      cmsAdapter.fetchEvent(languageKey, alias, setContent);
    } else {
      cmsAdapter.fetchNode(languageKey, node_id, setContent);
    }
  };
  const getMasterpreisHomepage = async () => {
    const data = await cmsAdapter.fetchMasterpreisHomepage(languageKey);
    setContent(data);
  };
  return {
    getContentByHash,
    getContentByNodeID,
    getMasterpreisHomepage,
    setContent
  };
};
export default useContentMethods;